/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/*
 * Custom code goes here.
 * A template should always ship with an empty custom.js
 */
var mm_dataone_config = {
  "owner_id": 188,
  "forms": [
    // ITA
    {
      "form_type": 'contatti ITA',
      "form_id": '#contact_form',
      "term_id": 'a693aa5f-b08a-433e-bec6-760b601328ee', 
      "classes_add": [
        ['[name="contact[name]"]', 'mm-prv-name'],
        ['[name="contact[email]"]', 'mm-prv-email'],
        ['[name="contact[Il tuo telefono (opzionale)]"]', 'mm-prv-telephone'],
        ['[name="privacy"]','dati_personali']
      ],
      "submit": '.Form__Submit',
      "el_to_remove": [],
      "el_to_wrap": '.privacy-control',
      "el_to_before": '',
      "el_to_hide": []
    },
    {
      "form_type": 'registrati ITA',
      "form_id": '#create_customer',
      "term_id": 'a693aa5f-b08a-433e-bec6-760b601328ee', 
      "classes_add": [
        ['[name="customer[first_name]"]', 'mm-prv-name'],
        ['[name="customer[email]"]', 'mm-prv-email'],
        ['[name="customer[last_name]"]', 'mm-prv-surname'],
        ['[name="privacy"]','dati_personali']
      ],
      "submit": '.Form__Submit',
      "el_to_remove": [],
      "el_to_wrap": '.privacy-control',
      "el_to_before": '',
      "el_to_hide": []
    },
    {
      "form_type": 'newsletter ITA',
      "form_id": '#footer-newsletter-mmone',
      "term_id": 'a693aa5f-b08a-433e-bec6-760b601328ee', 
      "classes_add": [
        ['[name="contact[email]"]', 'mm-prv-email']
      ],
      "submit": '.Form__Submit',
      "el_to_remove": [],
      "el_to_wrap": '.privacy-control',
      "el_to_before": '',
      "el_to_hide": []
    }
  ]
}

var mm_dataone = {
  /* multi form case with bootsrap nav */
  init: function (activetab) {

    function microtime() {
      /* cache busting */
      var d = new Date();
      var n = d.getTime();
      return n;
    }
    
    $('head').append('<link data-cssone="1" rel="stylesheet" type="text/css" href="https://static.dataone.online/widget/mmprvwidget.css?d=' + microtime() + '">');
    $('head').append('<link href="https://static.dataone.online/cookiebar/js/cookie.bundle.js" rel="preload" as="script">');
    $('body').append('<div id="mm-cookie-app" data-language="it" data-owner="188"></div><script src="https://static.dataone.online/cookiebar/js/cookie.bundle.js" ></script>');
    
    var forms = mm_dataone_config.forms; 

    /* reduce object with tab form active */
    /* decomment for multiple form in tabs */
    // var tmp = [];
    // $.each(forms, function (index,val) {
    //   if (val.form_id == '#'+$(activetab).find(val.form_id).attr('id')) {
    //     tmp.push(val);
    //     return false;
    //   }
    // });

    // forms = tmp;
  
    /* loop array forms */
    $.each(forms, function (index, form) {
      if ($(form.form_id).length > 0) {
        $('form').removeClass('mm-prv-form');
        //$('<div class="field"><div class="field__input-wrapper"><input class="dati_personali" type="checkbox" name="privacy" id="privacy" value="1"><label>Privacy</label></div></div>').append(form.form_class + ' .address-fields');
        
        $(form.form_class).removeAttr('onsubmit');
        /* main class assign */
        if ($(form.form_id).is("form")) { /* check if element is form */
          $(form.form_id).addClass('mm-prv-form');
        } else {
          $(form.form_id).find('form').addClass('mm-prv-form');
        }

        /* get submit text and classes */
        var submit_text = $(form.form_id).find(form.submit).html();
        var submit_classes = $(form.form_id).find(form.submit).attr('class');

        /* add dataone classes to fields */
        $.each(form.classes_add, function (idx, field) {
          $(form.form_id).find(field[0]).addClass(field[1]);
        });

        /* find submit button and add dataone classes */
        $(form.form_id).find(form.submit).addClass('mm-prv-form-submit');
        
        /* elements to remove */
        $.each(form.el_to_remove, function (idx, remove) {
          $(form.form_id).find(remove).remove();
        });
        
        /* append dataone wrapper */
        /* case to wrap */
        if (form.el_to_wrap != '' && $(form.form_id).find(form.el_to_wrap).length > 0) {
          $(form.form_id).find(form.el_to_wrap).wrapAll('<div id="mm-prv-wdg"></div>');
        }
        /* case append */
        if (form.el_to_before != '' && $(form.form_id).find(form.el_to_before).length > 0) {
          $('<div id="mm-prv-wdg"></div>').insertBefore($(form.form_id).find(form.el_to_before));
        }
        /* case custom */
        $(form.form_id).find('[name="privacy"]').closest('.col-12').find('.w-100').wrapAll('<div id="mm-prv-wdg"></div>');

        /* add hiddens */
        $.each(form.el_to_hide, function (idx, hidden) {
          $('<input type="hidden" name="' + hidden[0] + '" value="' + hidden[1] + '">').insertBefore($('#mm-prv-wdg'));
        });

        var getLangCode = $('html').attr('lang');
        var term_id = form.term_id;
        /* setting */
        window.prwidget = {
          language: getLangCode,
          submitCaption: submit_text,
          submitClass: submit_classes,
          submitAttributes: [],
          ownerId: mm_dataone_config.owner_id,
          termId: term_id
        }
        /* append js widget */
        $.getScript('https://static.dataone.online/widget/mmprvwidget.js?d=' + microtime());
        return false;
      }
    });
  }
}
mm_dataone.init();
